import { AZURE_CLIENT_ID, CURRENT_SUBDOMAIN, DEFAULT_SUBDOMAIN, DOMAIN } from '@/constants/env'
import { LogLevel, PublicClientApplication } from '@azure/msal-browser'
import { useSession } from './session'
import { ref } from 'vue'
import { getCookieValue } from '@/utils/cookies'
import { useOnboarding } from './onboarding'
import events from '@/events'

const { ssoAuth, login, createSubdomainURL } = useSession()
const termsAndConditionsRef = ref<any>(null)
const phoneNumberRef = ref<any>(null)
const ssoCreateAccountRef = ref<any>(null)

const userObj = ref<any>({})
const ssoRedirectURL = ref<string>(createSubdomainURL(DEFAULT_SUBDOMAIN, `/sso?subdomain=${CURRENT_SUBDOMAIN}`))

export const useSSO = () => {
  // Config object to be passed to Msal on creation
  const msalConfig = {
    auth: {
      clientId: AZURE_CLIENT_ID || '',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: `https://reactwork${DOMAIN}${process.env.VUE_APP_MODE === 'development' ? ':3000' : ''}/login`, // Must be registered as a SPA redirectURI on your app registration
      postLogoutRedirectUri: `https://reactwork${DOMAIN}${process.env.VUE_APP_MODE === 'development' ? ':3000' : ''}/login` // Must be registered as a SPA redirectURI on your app registration
    },
    cache: {
      cacheLocation: 'localStorage'
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) {
            return
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message)
              return
            case LogLevel.Info:
              console.info(message)
              return
            case LogLevel.Verbose:
              console.debug(message)
              return
            case LogLevel.Warning:
              console.warn(message)
          }
        },
        logLevel: LogLevel.Verbose
      }
    }
  }

  const msalInstance = new PublicClientApplication(msalConfig)

  const loginMS = async (subDomain: string) => {
    const loginRequest = {
      scopes: ['user.read']
    }
    msalInstance.loginPopup(loginRequest).then(async (result: any) => {
      userObj.value = { uuid: result.uniqueId, accessToken: result.accessToken, provider: 'microsoft', subDomain }
      showLoader(true)
      const res = await ssoAuth('microsoft', userObj.value)
      showLoader(false)
      if (res.status === 404) {
        window.parent.postMessage({ status: 404, data: userObj.value, resource: 'sso' }, '*')
      } else if (res.success) {
        window.parent.postMessage({ status: 200, data: userObj.value, resource: 'sso' }, '*')
      } else {
        window.parent.postMessage({ status: 500, data: userObj.value, resource: 'sso' }, '*')
      }
    })
  }

  const showLoader = (show: any) => {
    window.parent.postMessage({ loading: show, resource: 'ssoLoader' }, '*')
  }

  const { getCurrentOnboardingState } = useOnboarding()

  return {
    loginMS,
    termsAndConditionsRef,
    phoneNumberRef,
    ssoCreateAccountRef,
    userObj,
    getCookieValue,
    getCurrentOnboardingState,
    ssoRedirectURL,
    showLoader
  }
}
